import AuthInterceptor from "vamos/cockpit/base/services/type/AuthInterceptor";
import LoginService from "vamos/cockpit/login/LoginService";
import DebugHandler from "vamos/cockpit/base/handler/DebugHandler";

DebugHandler.handle();

// must happen before the very first backend request of this app
AuthInterceptor.install();

const loginService = new LoginService();
loginService.checkLogin();
